import { Button, Flex } from 'antd';
import { FunctionComponent } from 'react';

// components
import Icon from 'utils/icon';

// styles
import styles from '../pages/dashboard.module.scss';
import { isRTL } from 'core/services/language';

interface SupportBtnProps {
	type: 'account_manager' | 'technical' | 'emergency';
	title: string;
	subtitle: string;
	onClick: () => void;
}
const SupportBtn: FunctionComponent<SupportBtnProps> = ({ type, title, subtitle, onClick }) => {
	return (
		<Button block variant="filled" className={styles.supportBtn} onClick={onClick}>
			<Flex align="center" gap={20}>
				<span className={styles.supportBtn_icon}>
					<Icon name={type} />
				</span>
				<div>
					<p className="fw-medium">{title}</p>
					<p className="text-light small">{subtitle}</p>
				</div>
			</Flex>
			<Icon name="rightArrow" color="#555" style={{ transform: isRTL() ? 'rotate(180deg)' : 'unset' }} />
		</Button>
	);
};

export default SupportBtn;
